import { render, staticRenderFns } from "./scenic-info.vue?vue&type=template&id=4ed732ad&scoped=true&"
import script from "./scenic-info.vue?vue&type=script&lang=js&"
export * from "./scenic-info.vue?vue&type=script&lang=js&"
import style0 from "./scenic-info.vue?vue&type=style&index=0&id=4ed732ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed732ad",
  null
  
)

export default component.exports